@if (tab().underconstruction) {
    <button
        *ngIf="!hideByZeroCount() || tab().id === selectedTab() || tab().titleParams?.count > 0"
        [title]="underconstructionKey() | transloco"
        [attr.disabled]="tab().disabled"
        class="bazis-tab-btn-native"
        part="native"
    >
        <slot></slot>
    </button>
} @else {
    @if (tab().routerLink) {
        <!-- если табы ссылочные, то активность таба = активности ссылки если табы будут см -->
        @if (!hideByZeroCount() || tab().isExactLink || tab().titleParams?.count > 0) {
            <button
                [attr.disabled]="tab().disabled"
                [routerLink]="tab().routerLink"
                routerLinkActive="bazis-tab-btn--selected"
                [routerLinkActiveOptions]="{ exact: tab().isExactLink }"
                class="bazis-tab-btn-native"
                #tabLink
                part="native"
            >
                <slot></slot>
            </button>
        }
    } @else {
        <!-- если таб это не ссылка, то активируем таб с текущим значением tabControl -->
        @if (!hideByZeroCount() || tab().id === selectedTab() || tab().titleParams?.count > 0) {
            <button
                [attr.disabled]="tab().disabled"
                class="bazis-tab-btn-native"
                part="native"
            >
                <slot></slot>
            </button>
        }
    }
}
